import React, { useEffect, useState } from 'react';
import { Text, Box, Flex, Image, Button, Heading } from 'rebass';
import { keyframes } from '@emotion/react';
import { ReactComponent as BabysFYLabel } from './assets/babyyearbookslabel.svg';
import Sidebar_bottom_image from './assets/Sidebar_bottom_image.png';
import { useWindowSize } from 'react-use';

// import reviewerImage from './assets/reviewer-image.png';
import Progress from './Progress';
import Footer from './Footer';
import { useCurrentMember } from 'members/hooks/index';

const rotate = keyframes`
  0% { transform: translateX(100%); }
  100% { transform: translateX(0);  }
`;
const reviews = [
    {
        review: <>
            <b>"The Best Keepsake in the Making!"</b>
            <br />
            <Text mt={2} fontSize={15} letterSpacing='-0.3px'> Joining the beta, I knew this would be special – but it’s even better than I imagined! As a busy new mom, it’s been so easy to capture Ellie’s firsts: her smiles, giggles, and even her messy spaghetti night. Knowing this will become a beautiful keepsake book? Absolutely priceless.</Text>
        </>,
        reviewer: 'Emily, First-Time Mom',
        // reviewerImage
    },
    {
        review: <>
            <b>“The Perfect Start to Capturing Our Memories!”</b>
            <br />
            <Text mt={2} fontSize={15} letterSpacing='-0.3px'> "When my parents gave me a Baby's First Year gift certificate, I was thrilled! This made it so easy to start documenting Lily’s milestones and adding photos and videos. It’s already becoming a beautiful collection of moments, and I can’t wait to see how it all comes together in the book."</Text>
        </>,
        reviewer: 'Sarah, Proud Mama of Noah',
        // reviewerImage
    }
]
const headingStyle = {
    color: '#0E0E0E',
    fontFamily: 'Bitter',
    fontSize: '35px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '120%',
    letterSpacing: '-0.21px',
}
export function LoginSection({ onLoginPress, showLogin }) {

    return <Text as="flex" textAlign="left" color="#64748B" fontFamily="Poppins" fontSize={16} letterSpacing="-2%" onClick={onLoginPress}>
        {!showLogin ?
            <>
                <i>
                    Already have an account?   <Text
                        as="span"
                        fontWeight={500}
                        color="#9B59B6"
                        sx={{
                            textDecorationLine: 'underline',
                            cursor: 'pointer',
                            zIndex: 9
                        }}
                    >
                        Sign in</Text>
                </i>
            </>
            : <>Not registered yet?  <Text
                as="span"
                fontWeight={500}
                color="#9B59B6"
                sx={{
                    textDecorationLine: 'underline',
                    cursor: 'pointer',
                    zIndex: 9
                }}
            >Create Account</Text>
            </>
        }
    </Text>
}

const Wrapper = ({ children, onStepDown, showFooter = true, isDisabled = false, showLoginButton = false, showLogin = false, noOfTransitions = 0, nextButtonText = "Continue", onSubmit, bg = "linkWater", isSubmitting, mainImage, percentComplete, toggleLogin, maxWidth,
    subText,
    onBack,
    backText,
    heading = 'The Perfect Gift for a Lifetime of Smiles',
    subHeading = 'With Baby’s First Year, you don’t just preserve memories; you bring them to life!',
    buttonSx, ...props }) => {
    const [animationStyle, setAnimationStyle] = useState({});
    const member = useCurrentMember();

    const { width } = useWindowSize();

    const animateElement = () => {
        setAnimationStyle((prevStyle) => ({
            ...prevStyle,
            opacity: 0,
            animation: 'unset',
        }));

        setTimeout(() => {
            setAnimationStyle((prevStyle) => ({
                ...prevStyle,
                opacity: 1,
                animation: `${rotate} 1s ease`,
            }));
        }, 500);
    };

    useEffect(() => {
        animateElement()
    }, [noOfTransitions])

    return (
        <Flex
            // mt={isUploading ? ['70px', '170px'] : ['10px', '100px']}
            {...props}
        >
            <Flex bg="white" width="100%" flexDirection={width < 600 ? 'column' : 'row'} height={width < 600 ? 'unset' : '100vh'} sx={{ position: width < 600 ? 'unset' : 'fixed' }}>
                {/* {isFromMobile ?
                    : */}
                {width < 600 ? <Flex flexDirection="column" alignItems="center" width="100%" >
                    <Progress percentComplete={percentComplete} width="100%" mb={2} />
                    <Box mb={1}>
                        <BabysFYLabel />
                    </Box>
                    {!member?.onboarded && showLoginButton && <LoginSection onLoginPress={toggleLogin} showLogin={showLogin} />}
                    <Image mt={1} width="100%" maxHeight={320} src={mainImage} sx={{ borderRadius: "15px" }} />
                </Flex> :
                    <Flex py="20px" px="1%" flexDirection="column" bg={bg} width={["100%", "30%", "30%"]} minWidth={320} >
                        <Box pb="20px" >
                            <BabysFYLabel />
                        </Box>
                        <Heading mb="16px" sx={headingStyle}>{heading}</Heading>
                        <Text
                            mb="33px"
                            color="#34495E"
                            fontSize={18}
                            fontFamily="Poppins"
                            lineHeight="150%"
                            fontWeight={400}
                            letterSpacing="-0.36px"
                        >
                            {subHeading}
                        </Text>
                        {reviews.map(({ review, reviewer, reviewerImage }) => <Box mb='30px' >
                            <Text
                                mb={1}
                                color="#000"
                                fontSize={16}
                                fontFamily="Poppins"
                                lineHeight="150%"
                                fontWeight={400}
                                letterSpacing="-0.28px"
                                sx={{ borderRadius: '8px' }}
                                bg="white"
                                p='20px'
                            >
                                {review}
                            </Text>
                            <Flex alignItems="center" >
                                {/* <Image src={reviewerImage} mr={2} sx={{ borderRadius: '50%' }} /> */}
                                <Text
                                    color="#34495E"
                                    fontSize={13}
                                    fontFamily="Poppins"
                                    lineHeight="150%"
                                    fontWeight={400}
                                    letterSpacing="-0.26px"
                                >{reviewer}</Text>
                            </Flex>
                        </Box>
                        )}
                        <Image src={Sidebar_bottom_image} maxWidth={308} mx="auto" />
                    </Flex>}
                <Flex
                    sx={animationStyle}
                    flexDirection="column" width={width < 600 ? "100%" : "calc(100vw - 30%)"} px={2} bg="white" >
                    <Box height={['auto', 'auto', 'auto', 'auto']} sx={{ overflow: 'auto', pt: 4, mb: 0 }}>
                        {children}
                    </Box>
                    {/* {isFromMobile && showFooter &&
                        <Flex justifyContent="space-between" mt={2}>
                            {onStepDown &&
                                <Flex
                                    height={60}
                                    justifyContent="space-around"
                                    alignItems="center"
                                    bg="#fff"
                                    sx={{ borderRadius: 'medium', cursor: 'pointer' }}
                                    onClick={onStepDown}
                                >
                                    <Text as={IoIosArrowRoundBack} color="mineShaft" minWidth={"24px"} fontSize={24} />
                                </Flex>}
                            <Button
                                height={40}
                                py={1}
                                px={5}
                                bg="brand"
                                onClick={onSubmit}
                                disabled={isSubmitting}
                                sx={{
                                    borderRadius: '23px',
                                    width: 'max-content',
                                    my: 1,
                                    display: 'flex', justifyContent: 'center', alignItems: 'center',
                                    ml: 'auto'
                                }}
                            >
                                {nextButtonText}
                            </Button>
                        </Flex>
                    } */}
                    {showFooter &&
                        <Flex mt="auto">
                            {!member?.onboarded && showLoginButton && <Box sx={{ position: "absolute", zIndex: 9 }} mt="40px" ml="20px" onClick={toggleLogin}>
                                <LoginSection onLoginPress={toggleLogin} showLogin={showLogin} />
                            </Box>}
                            <Footer buttonSx={buttonSx} isDisabled={isDisabled} mt={0} disabled={isSubmitting} onNextPress={onSubmit} percentComplete={percentComplete} nextButtonText={nextButtonText}
                                backText={backText}
                                onBack={onBack} />
                        </Flex>}
                </Flex>
            </Flex>
        </Flex >
    );
};

export default Wrapper;
